import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  OrdenCurado,
  OrdenesCuradoRespSchema,
  ProgresoCurado,
  ProgresoCuradoRespSchema,
} from '../data/schemas/curado.schema';
import { Plant } from '../data/schemas/session.schema';

/** Empresa y planta sobre las que se consulta el curado. */
export type CuradoContexto = Pick<Plant, 'companyCode' | 'plantCode'>;

/** Órdenes de curado abiertas y el progreso de sus lotes. */
export abstract class CuradoDataService {
  abstract ordenes(contexto: CuradoContexto): Observable<OrdenCurado[]>;
  abstract progreso(contexto: CuradoContexto): Observable<ProgresoCurado[]>;
}

/** Implementación real: `GET /seeds/open` y `GET /seeds/active-lots`, validados con Zod y sin fallback. */
@Injectable()
export class CuradoApiService extends CuradoDataService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/seeds`;

  ordenes(contexto: CuradoContexto): Observable<OrdenCurado[]> {
    return this.http
      .get<unknown>(`${this.baseUrl}/open`, { params: toParams(contexto) })
      .pipe(map((res) => OrdenesCuradoRespSchema.parse(res)));
  }

  progreso(contexto: CuradoContexto): Observable<ProgresoCurado[]> {
    return this.http
      .get<unknown>(`${this.baseUrl}/active-lots`, { params: toParams(contexto) })
      .pipe(map((res) => ProgresoCuradoRespSchema.parse(res)));
  }
}

function toParams({ companyCode, plantCode }: CuradoContexto): HttpParams {
  return new HttpParams().set('Empresa_Codigo', companyCode).set('Planta_Codigo', plantCode);
}
